export const STORE_KEY = '$_home';


export const GET_HOMEPAGE_SLIDE = 'GET_HOMEPAGE_SLIDE';